import React, { useEffect } from 'react';
import Select, { StylesConfig } from 'react-select';
import { ISelectOption } from '../ISelectOption';
import { VShift } from '../../../utils/types/VShift';

interface ShiftSelectProps {
    items: VShift[];
    isItemsLoading: boolean;
    setSelectedItemId: (id: number | null) => void;
    selectedItemId: number | null;
    isDisabled?: boolean | null;
}

const ShiftSelect: React.FC<ShiftSelectProps> = ({ items, isItemsLoading, setSelectedItemId, selectedItemId, isDisabled }) => {
    const options: ISelectOption[] = items
        .map((item) => ({
            value: item.id ? item.id.toString() : '',
            label: item.code ?? '-',
        }))
        .filter((option) => option.value !== '');

    const isGhost = selectedItemId !== null && !items.some((item) => item.id === selectedItemId);
    const selectedOption = options.find((option) => parseInt(option.value) === selectedItemId) || (selectedItemId !== null ? { value: selectedItemId.toString(), label: '⚠️ Introuvable' } : null);

    const handleChange = (selectedOption: ISelectOption | null) => {
        setSelectedItemId(selectedOption ? parseInt(selectedOption.value) : null);
    };

    const customStyles: StylesConfig<ISelectOption, false> = {
        control: (provided) => ({
            ...provided,
            width: 'auto',
            minWidth: '150px',
            maxWidth: '100%',
        }),
        singleValue: (provided) => ({
            ...provided,
            whiteSpace: 'nowrap',
            color: isGhost ? 'red' : provided.color,
        }),
        menu: (provided) => ({
            ...provided,
            width: 'auto',
            minWidth: '150px',
        }),
        option: (provided) => ({
            ...provided,
            whiteSpace: 'nowrap',
        }),
        menuPortal: (provided) => ({
            ...provided,
            zIndex: 9999,
        }),
    };

    // useEffect(() => {
    //     if (selectedItemId !== null && !items.some((item) => item.id === selectedItemId)) {
    //         setSelectedItemId(null);
    //     }
    // }, [items, selectedItemId, setSelectedItemId]);

    return <Select id="autoSizingSelect" value={selectedOption} options={options} onChange={handleChange} placeholder={isItemsLoading ? 'Chargement ...' : '--- Shift'} isLoading={isItemsLoading} isClearable isSearchable noOptionsMessage={() => 'Aucun shift'} styles={customStyles} classNamePrefix="react-select" isDisabled={isDisabled ?? false} menuPortalTarget={document.body} />;
};

export default ShiftSelect;
